import {useEffect, useState} from "react";
/* Contexts */
import useData from "../../../hooks/useData";
import useDeceased from "../../../hooks/useDeceased";
/* Components */
import DashboardLine from "./DashboardLine";
import PagingDashboard from "./PagingDashboard";


export default function Dashboard({
    tab,
    location,
    dataObject,
    order,
    agenciesApi,
    apiUserList,
    activitiesApi,
    documentsApi,
    apiCADList,
    apiNetworkList,
    deceasedListApi,
    apiEstimateTemplateList,
    totalItems,
}) {
    const {
        data,
        dataList, setDataList,
    } = useData();
    const { deceased } = useDeceased();

    useEffect(() => {
        if (dataObject?.length > 0) {
            setDataList(dataObject)
        } else {
            setDataList([])
        }
    }, [ dataObject ]);

    let displayedIndexes = {};
    if (location === "Tableau de bord") {
        displayedIndexes = {
            "lastName": "Nom Prénom",
            "deathDateNotFormatted": "Décès",
            "ceremonyDateNotFormatted": "Date de cérémonie",
            "condolenceMessages": "Messages de condoléances",
        }
    } else if (location === "Agences") {
         displayedIndexes = {
             "authorizationCode": "Code d'habilitation",
             "name": "Nom",
             "city": "Ville",
             "activity": "Activités",
             "siret": "Siret",
             "createdAtNotFormatted": "Date de création",
         }
    } else if (location === "Utilisateurs") {
        displayedIndexes = {
            "id": "Id",
            "name": "Nom",
            "city": "Ville",
            "roles": "Rôle",
            "firstName": "Utilisateur",
            "createdAtNotFormatted": "Date de création",
            "lastLoginNotFormatted": "Dernière connexion",
        }
    } else if (location === "Agence - Utilisateurs") {
        displayedIndexes = {
            "roles": "Rôle",
            "firstName": "Prénom",
            "lastName": "Nom",
            "email": "Email",
            "createdAtNotFormatted": "Date de création",
            "lastLoginNotFormatted": "Dernière connexion",
        }
    } else if (location === "Activités") {
        displayedIndexes = {
            "name": "Type d'activité",
        }
    } else if (location === "Emails") {
        displayedIndexes = {
            "id": "Id",
            "description": "Description",
            "subject": "Sujet"
        }
    } else if (location === "Documents" && tab === "documents") {
        displayedIndexes = {
            "name": "Nom",
            "description": "Description",
            "createdAtNotFormatted": "Date de création",
            "updatedAtNotFormatted": "Date de modification",
            "url": "Source",
        }
    } else if (location === "Devis") {
        displayedIndexes = {
            "sectionLine": "Numéro de ligne",
            "description": "Description",
            "dataInput": "Données",
            "usualAvailable": "Prestations obligatoires TTC",
            "complementaryAvailable": "Prestations non obligatoires TTC",
            "tvaRate": "TVA",
            "enabled": "Activé"
        }
    } else if (location === "Courriers après décès") {
        displayedIndexes = {
            "id": "Id",
            "name": "Nom",
            "description": "Description",
            "category": "Catégorie",
            "type": "Type",
        }
    } else if (location === "Documents" && tab === "devis") {
        displayedIndexes = {
            "section": "Numéro",
            "description": "Description",
        }
    } else if (location === "Villes") {
        displayedIndexes = {
            "zipcode": "Code postal",
            "city": "Ville",
            "county": "Département",
        }
    } else if (location === "Produits facturables") {
        displayedIndexes = {
            "name": "Produit Facturables",
            "default_price": "Prix de vente à l'agence par défaut",
            "default_percent": "Reversement au réseau par défaut",
            "advised_resell": "Prix de vente client conseillé",
        }
    } else if (location === "Réseaux") {
        displayedIndexes = {
            "name": "Nom",
            "siret": "Siret",
            "createdAtNotFormatted": "Date de création",
        }
    } else if (location === "Défunts") {
        displayedIndexes = {
            "id": "Id",
            "agency": "Agence",
            "lastName": "Nom",
            "firstName": "Prénom",
            "deathDateNotFormatted": "Décès",
            "createdAtNotFormatted": "Date de création",
        }
    }
    const filteredIndexes = order.filter(idx => displayedIndexes[idx]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

    const displayFieldForIdx = {
        deathDateNotFormatted: "deathDate",
        ceremonyDateNotFormatted: "ceremonyDate",
        createdAtNotFormatted: "createdAt",
    };

    const getSortableValue = (value) => {
        if (typeof value === "string") {
            const dateMatch = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
            if (dateMatch) {
                const [, day, month, year] = dateMatch;
                return `${year}-${month}-${day}`;
            }
        }
        return value;
    };

    const handleSort = (idx) => {
        const sortField = displayFieldForIdx[idx] || idx;
        const direction = sortConfig.key === idx && sortConfig.direction === 'ascending' ? 'descending' : 'ascending';
        const sortedData = [...dataList].sort((a, b) => {
            const valueA = getSortableValue(a[sortField]);
            const valueB = getSortableValue(b[sortField]);
            if (valueA < valueB) {
                return direction === 'ascending' ? -1 : 1;
            }
            if (valueA > valueB) {
                return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
        setDataList(sortedData);
        setSortConfig({ key: idx, direction });
    };

    /*const handleSort = (idx) => {
        const sortedData = dataList.sort((a, b) => {
            if (a[idx] < b[idx]) {
                return -1
            }
            if (a[idx] > b[idx]) {
                return 1
            }
            return 0
        })
        setDataList(sortedData)
    }*/

    return (
        <>
            <table key={'table'+location} className={location === "Tableau de bord" ? "home-deceased-table" : ""}>
                <thead className="dashboard-header">
                <tr>
                    { filteredIndexes.map((idx) => (
                        <th
                            key={'th'+idx}
                            className={ location.toLowerCase() }
                            onClick={() => handleSort(idx)}
                            id={ idx }>
                            { displayedIndexes[idx] }
                            <i  className="fa fa-sort"/>
                        </th>
                    ))}
                    { ( location !== "Agence - Utilisateurs" &&
                        location !== "Défunts" && location !== "Catégories") &&
                        <th key={'thactions'} id="actions">Actions</th>
                    }
                </tr>
                </thead>
                <tbody key={'tbody'+location}>
                { (dataList?.length > 0) ? dataList.map(singleData => (
                        <DashboardLine
                            apiEstimateTemplateList={ apiEstimateTemplateList }
                            deceasedListApi={ deceasedListApi }
                            apiNetworkList={ apiNetworkList }
                            apiCADList={ apiCADList }
                            documentsApi={ documentsApi }
                            activitiesApi={ activitiesApi }
                            apiUserList={ apiUserList }
                            agenciesApi={ agenciesApi }
                            tab={ tab }
                            location={ location }
                            isSelected={
                                (location === "Tableau de bord" || location === "Défunts")
                                    ? (deceased && singleData.id === deceased.id ? "selected" : "")
                                    : (data && singleData.id === data.id ? "selected" : "")
                            }
                            key={ 'tr'+singleData.id }
                            line={ singleData }
                            thIndexes={ order }
                            deleted={ (singleData.agencyEnabled === false ||
                                singleData.userEnabled === false ||
                                singleData.activityEnabled === false ||
                                singleData.cadEnabled === false ||
                                singleData.enabled === false ||
                                (singleData.isListed !== undefined && !singleData.isListed))
                                ? "deleted"
                                : "" }
                        />
                    )) :
                    <tr>
                        <td colSpan={ filteredIndexes.length + 1 }>
                            Pas de données pour cette recherche.
                        </td>
                    </tr>
                }
                </tbody>
            </table>
            <div className="errors"></div>
            <PagingDashboard totalItems={totalItems} />
        </>
    )
}